<template>
  <v-layout column justify-center align-center class="mt-4 pt-2">
    <VueCompareImage
      class="hidden-md-and-down"
      hover
      :style="{ minWidth: '1300px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage"
      :rightImage="rightImage"
      :sliderPositionPercentage="sliderPosition"
    />
    <VueCompareImage
      class="hidden-lg-and-up"
      hover
      :style="{ maxWidth: '400px' }"
      :sliderLineWidth="sliderLine"
      :handleSize="hSize"
      :leftImage="leftImage2"
      :rightImage="rightImage2"
      :sliderPositionPercentage="sliderPosition"
    />

    <br>

    <vue-typer class="headline" :repeat="0" text="Luis Silva"></vue-typer>
    <vue-typer
      :text="text1"
      :repeat="Infinity"
      :shuffle="false"
      initial-action="erasing"
      :pre-type-delay="70"
      :type-delay="70"
      :pre-erase-delay="1980"
      :erase-delay="150"
      erase-style="select-back"
      :erase-on-complete="false"
      caret-animation="smooth"
    ></vue-typer>
    <br>
    <v-flex xs12 sm6 md6 lg6 xl6>
      <v-card flat color="transparent" max-width="520" style="text-align: justify">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">
              <span>Embark your IT needs with the</span>
              <span class="blue--text"> Silva's Way!</span>
            </h3>
            <div>
              <br>
              <p>
                I am honored to have you visit my IT contracting space. Whether you are a new visitor or a valued returning client, I strive to provide an environment that is both professional and welcoming.
                <br>
<br>
                At <span
                  class="blue--text font-weight-bold"
                >Silva's SCS</span>, I specialize in web development services and have proudly served the industry for over <b>{{ new Date().getFullYear() - 2015 }} years </b>.
                <br>        <br>
                
                As a dedicated professional, my primary focus is <b>ensuring that my clients are happy and that my services add significant value to their businesses</b>. I am committed to delivering exceptional IT solutions tailored to meet the specific needs of my clients, ensuring that your technology infrastructure operates efficiently and effectively, allowing you to concentrate on your core business activities.
                 <br>
                 <br>
Please feel free to explore the facilities, engage with me, and learn more about how I can assist you in achieving your objectives. I am here to support you in every possible way.
<br>
<br>
Thank you for choosing <span
                  class="blue--text font-weight-bold"
                >Silva's SCS</span>. I look forward to the opportunity to serve you.
 
              </p>
            </div>
          </div>
        </v-card-title>

        <v-card-actions class="hidden-sm-and-down">
          <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions class="hidden-md-and-up justify-left">
          <v-btn
            v-for="icon in icons"
            :key="icon.icon"
            small
            fab
            dark
            outline
            color="blue"
            :href="icon.href"
            target="_blank"
          >
            <v-icon dark>{{icon.icon}}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueTyper } from "vue-typer";
import VueCompareImage from "vue-compare-image";

export default {
  metaInfo: {
    title: "Home",
    titleTemplate: "%s ← IT Contractor | Silva's SCS Inc",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "description", content: "Silva's Portfolio" },
      { charset: "utf-8" },
      { property: "og:title", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:site_name", content: "IT Contractor | Silva's SCS Inc" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://silvassoftwareconsultingservices.com" },
      {
        property: "og:image",
        content: "/favicon_io/apple-touch-icon.png"
      },
      { property: "og:description", content: "Silva's Portfolio" }
    ]
  },
  components: {
    "vue-typer": VueTyper,
    VueCompareImage
  },
  data() {
    return {
      icons: [
      {  },
      {  },
      {  },
        { href: "https://gitlab.com/LuisSilva2014", icon: "fab fa-github" },
        // {
        //   href: "https://stackoverflow.com/users/story/9660700",
        //   icon: "fab fa-stack-overflow"
        // },
        // { href: "https://twitter.com/EldinMatricar", icon: "fab fa-twitter" },
        {
          href: "https://www.linkedin.com/in/luis-silva-spm",
          icon: "fab fa-linkedin-in"
        },
        // {
        //   href: "https://www.xing.com/profile/Eldin_Zaimovic?sc_o=mxb_p",
        //   icon: "fab fa-xing"
        // },
        // {
        //   href: "https://www.facebook.com/EldinVasVoli",
        //   icon: "fab fa-facebook-f"
        // },
        // { href: "https://www.instagram.com/matricar", icon: "fab fa-instagram" } {  },
        {  },
        {  },
        {  },
      ],
      text1: ["Senior FullStack Web Developer", "Nearshore/Specialized IT Contractor", "Your partner and ally in web development"],
      leftImage: "/sscs_slide_1.jpg", // https://i.imgur.com/eqkEJxa.jpeg", // "https://i.imgur.com/bU50uS9.jpg", https://imgur.com/eqkEJxa
      rightImage:  "/sscs_slide_2.jpg", // https://i.imgur.com/ZFFJSsQ.jpeg", // "https://i.imgur.com/z3ZoEEw.jpg",
      leftImage2: "/sscs_portrait1.jpeg",
      rightImage2: "/sscs_portrait2.jpeg",
      sliderLine: 0,
      hSize: 0,
      sliderPosition: 0.69
    };
  }
};
</script>
<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }

  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: #609cd2;
}
.vue-typer .custom.char.selected {
  color: #e91e63;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: #609cd2;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #e91e63;
}
</style>

